"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _CustomError = require("./CustomError");
Object.keys(_CustomError).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _CustomError[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _CustomError[key];
        }
    });
});
var _CustomErrorOptions = require("./CustomErrorOptions");
Object.keys(_CustomErrorOptions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _CustomErrorOptions[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _CustomErrorOptions[key];
        }
    });
});
var _CustomErrorWithData = require("./CustomErrorWithData");
Object.keys(_CustomErrorWithData).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _CustomErrorWithData[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _CustomErrorWithData[key];
        }
    });
});
var _CustomErrorWithDataOptions = require("./CustomErrorWithDataOptions");
Object.keys(_CustomErrorWithDataOptions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _CustomErrorWithDataOptions[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _CustomErrorWithDataOptions[key];
        }
    });
});
var _ErrorMessages = require("./ErrorMessages");
Object.keys(_ErrorMessages).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _ErrorMessages[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _ErrorMessages[key];
        }
    });
}); //# sourceMappingURL=index.js.map
